
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m21.492 7.336-9.144-4.078a.85.85 0 0 0-.697 0L2.508 7.336a.856.856 0 0 0-.054 1.537l9.143 4.876a.851.851 0 0 0 .806 0l9.144-4.876a.857.857 0 0 0-.055-1.537Z"}}),_c('path',{attrs:{"d":"M20.74 10.984 12 15.647l-8.74-4.663a.855.855 0 1 0-.806 1.51l9.143 4.879a.855.855 0 0 0 .806 0l9.144-4.878a.857.857 0 0 0-.807-1.51Z"}}),_c('path',{attrs:{"d":"M20.74 14.329 12 18.99 3.26 14.33a.855.855 0 1 0-.806 1.51l9.143 4.876a.849.849 0 0 0 .806 0l9.144-4.876a.857.857 0 0 0-.807-1.51Z"}})])
          )
        }
      }
    